import { previewPhrases } from './previewPhrases';
import { previewPhraseMinimumWidth } from './previewPhraseMusicXml';
import { previewStaffSpace } from './renderPreviewPhraseSvg';

// A level with no notation falls back to its picture, which reads down to 72px high; the
// pictures are about 4.6 times as wide as they are high.
const PICTURE_MIN_HEIGHT = 72;
const PICTURE_WIDTH_PER_HEIGHT = 654 / 142;

// The narrowest width at which every level's phrase still reads, drawn `height` high.
export const previewPhrasesMinimumWidth = (height: number): number =>
  Math.max(
    ...Object.values(previewPhrases).map((phrase) =>
      previewPhraseMinimumWidth(phrase, previewStaffSpace(height)),
    ),
  );

// Whether there is room for the level's preview, drawn `height` pixels high, at `width`
// pixels; below that the preview is hidden rather than squeezed. The bar is the same
// for every level with notation (the busiest phrase sets it), so moving between levels
// never shows and hides the preview at one window size.
export const previewPhraseFits = (levelNumber: number, width: number, height: number): boolean =>
  previewPhrases[levelNumber]
    ? width >= previewPhrasesMinimumWidth(height)
    : width >= PICTURE_MIN_HEIGHT * PICTURE_WIDTH_PER_HEIGHT;
